import { render, staticRenderFns } from "./BaseTextCollapse.vue?vue&type=template&id=03546f60&"
import script from "./BaseTextCollapse.vue?vue&type=script&lang=js&"
export * from "./BaseTextCollapse.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextCollapse.vue?vue&type=style&index=0&id=03546f60&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports